import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters89mmClearViewMidRailRevealFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters89"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={405.67}
          y1={489.91}
          x2={405.67}
          y2={485.25}
          gradientTransform="translate(.5 -431.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={405.67}
          y1={519.52}
          x2={405.67}
          y2={514.86}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={405.67}
          y1={549.04}
          x2={405.67}
          y2={544.38}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={405.67}
          y1={578.47}
          x2={405.67}
          y2={573.81}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={405.67}
          y1={607.99}
          x2={405.67}
          y2={603.33}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={405.67}
          y1={669.84}
          x2={405.67}
          y2={665.19}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={405.67}
          y1={699.29}
          x2={405.67}
          y2={694.64}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={405.67}
          y1={728.75}
          x2={405.67}
          y2={724.09}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={405.67}
          y1={758.2}
          x2={405.67}
          y2={753.55}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={405.67}
          y1={787.65}
          x2={405.67}
          y2={783}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={40.93}
          y1={501.73}
          x2={40.93}
          y2={471.78}
          gradientTransform="translate(.5 -431.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={7082.88}
          y1={501.73}
          x2={7082.88}
          y2={471.78}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={40.93}
          y1={532.14}
          x2={40.93}
          y2={502.2}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7082.88}
          y1={532.14}
          x2={7082.88}
          y2={502.2}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={40.93}
          y1={562.44}
          x2={40.93}
          y2={532.5}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7082.88}
          y1={562.44}
          x2={7082.88}
          y2={532.5}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={40.93}
          y1={592.66}
          x2={40.93}
          y2={562.72}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7082.88}
          y1={592.66}
          x2={7082.88}
          y2={562.72}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={40.93}
          y1={622.97}
          x2={40.93}
          y2={593.02}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7082.88}
          y1={622.97}
          x2={7082.88}
          y2={593.02}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={40.93}
          y1={680.43}
          x2={40.93}
          y2={650.49}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7082.88}
          y1={680.43}
          x2={7082.88}
          y2={650.49}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={40.93}
          y1={710.75}
          x2={40.93}
          y2={680.8}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7082.88}
          y1={710.75}
          x2={7082.88}
          y2={680.8}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={40.93}
          y1={741.04}
          x2={40.93}
          y2={711.1}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={7082.88}
          y1={741.04}
          x2={7082.88}
          y2={711.1}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={40.93}
          y1={771.37}
          x2={40.93}
          y2={741.39}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={7082.88}
          y1={771.37}
          x2={7082.88}
          y2={741.39}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={40.93}
          y1={801.63}
          x2={40.93}
          y2={771.69}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={7082.88}
          y1={801.63}
          x2={7082.88}
          y2={771.69}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <pattern
          id="prefix__SVGID_1_"
          data-name="SVGID 1"
          width={135}
          height={135}
          patternTransform="matrix(.96 0 0 .94 474.48 444.52)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image"
            className="prefix__cls-2"
            xlinkHref="#prefix__image-2-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_3"
          data-name="SVGID 1 3"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 -.94 491.84 521.17)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-2">
            <use
              id="prefix__image-3"
              data-name="image"
              className="prefix__cls-2"
              transform="matrix(1 0 0 -1 0 135)"
              xlinkHref="#prefix__image-2-2"
            />
          </g>
        </pattern>
        <style>
          {
            '.prefix__cls-1,.prefix__cls-10,.prefix__cls-4,.prefix__cls-5,.prefix__cls-7{fill:none}.prefix__cls-10,.prefix__cls-2,.prefix__cls-4,.prefix__cls-5{isolation:isolate}.prefix__cls-10,.prefix__cls-4,.prefix__cls-5,.prefix__cls-7{stroke:#4d4d4d;stroke-miterlimit:10}.prefix__cls-4{stroke-width:.95px}.prefix__cls-10,.prefix__cls-4,.prefix__cls-5{opacity:.15}.prefix__cls-5{stroke-width:.94px}.prefix__cls-7{stroke-width:.81px}.prefix__cls-8{opacity:.2}.prefix__cls-9{fill:#333}.prefix__cls-10{stroke-width:.91px}.prefix__cls-44{fill:gray;opacity:.2}'
          }
        </style>
        <image
          id="prefix__image-2-2"
          width={135}
          height={135}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAACHCAYAAAA850oKAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVR4Xu3SMRGAMADAwFL/xmqAHSXUQHMI4H/OmOu51zvgYH4F/Jc5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SBszfASNAbiFZQAAAABJRU5ErkJggg=="
        />
      </defs>
      <path
        d="M514.86 12.8H12.6v384.4h529.79V12.8zm0 357.33H297.5v-14h217.36zm0-18.61H297.5v-24.81h217.36zm0-29.51H297.5V297.2h217.36zm0-29.42H297.5v-24.81h217.36zm0-29.41H297.5v-24.82h217.36zm0-29.51H297.5V218.5h217.36zm0-42.2H297.5v-15h217.36zm0-19.65H297.5V147h217.36zm0-29.51H297.5V117.5h217.36zm0-29.41H297.5V88h217.36zm0-29.52H297.5v-25h217.36zm0-29.6H297.5V39.87h217.36z"
        fill="url(#shutters89)"
      />
      <path className="prefix__cls-4" d="M12.6 12.8h27.53v384.4H12.6z" />
      <path
        className="prefix__cls-5"
        d="M40.11 12.78h217.38v27.07H40.11zM40.16 370.16h217.38v27.07H40.16zM297.46 12.78h217.38v27.07H297.46zM297.51 370.15h217.38v27.07H297.51z"
      />
      <path className="prefix__cls-4" d="M514.86 12.8h27.53v384.4h-27.53z" />
      <g opacity={0.15}>
        <path
          className="prefix__cls-7"
          d="M257.52 12.8h19.98v384.4h-19.98zM277.5 12.8h19.98v384.4H277.5z"
        />
      </g>
      <g className="prefix__cls-8">
        <path
          className="prefix__cls-9"
          d="M12.6 72.39h2.49v35.81H12.6zM12.6 301.8h2.49v35.81H12.6z"
        />
      </g>
      <g className="prefix__cls-8">
        <path
          className="prefix__cls-9"
          d="M539.91 72.39h2.49v35.81h-2.49zM539.91 301.8h2.49v35.81h-2.49z"
        />
      </g>
      <path className="prefix__cls-10" d="M40.14 39.87h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient)"
        d="M297.48 53.78h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M297.48 83.38h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M297.48 112.9h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M297.48 142.31h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M297.48 171.82h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M297.48 233.67h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M297.48 263.18h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M297.48 292.59h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M297.48 322.01h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M297.48 351.52h217.38v4.7H297.48z"
      />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M42.24 40.34h-1.63v29.89l1.63-29.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M255.9 40.34h1.62v29.89l-1.62-29.89z"
      />
      <path className="prefix__cls-10" d="M40.14 70.23h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M42.24 70.7h-1.63v29.98l1.63-29.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M255.9 70.7h1.62v29.98L255.9 70.7z"
      />
      <path className="prefix__cls-10" d="M40.14 100.58h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M42.24 100.96h-1.63v29.98l1.63-29.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M255.9 100.96h1.62v29.98l-1.62-29.98z"
      />
      <path className="prefix__cls-10" d="M40.14 130.75h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M42.24 131.22h-1.63v29.98l1.63-29.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M255.9 131.22h1.62v29.98l-1.62-29.98z"
      />
      <path className="prefix__cls-10" d="M40.14 161.11h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M42.24 161.49h-1.63v29.98l1.63-29.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M255.9 161.49h1.62v29.98l-1.62-29.98z"
      />
      <path className="prefix__cls-10" d="M40.14 218.53h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M42.24 219h-1.63v29.89L42.24 219z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M255.9 219h1.62v29.89L255.9 219z"
      />
      <path className="prefix__cls-10" d="M40.14 248.8h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M42.24 249.27h-1.63v29.98l1.63-29.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M255.9 249.27h1.62v29.98l-1.62-29.98z"
      />
      <path className="prefix__cls-10" d="M40.14 279.15h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-25)"
        d="M42.24 279.62h-1.63v29.89l1.63-29.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-26)"
        d="M255.9 279.62h1.62v29.89l-1.62-29.89z"
      />
      <path className="prefix__cls-10" d="M40.14 309.42h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-27)"
        d="M42.24 309.89h-1.63v29.98l1.63-29.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-28)"
        d="M255.9 309.89h1.62v29.98l-1.62-29.98z"
      />
      <path className="prefix__cls-10" d="M40.14 339.77h217.38v30.26H40.14z" />
      <path
        fill="url(#prefix__linear-gradient-29)"
        d="M42.24 340.24h-1.63v29.89l1.63-29.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-30)"
        d="M255.9 340.24h1.62v29.89l-1.62-29.89z"
      />
      <path
        className="prefix__cls-5"
        d="M40.13 191.47h217.38v27.07H40.13zM297.48 191.46h217.38v27.07H297.48z"
      />
      <path
        style={{
          isolation: 'isolate',
        }}
        opacity={0.2}
        stroke="#4d4d4d"
        strokeMiterlimit={10}
        fill="none"
        d="M.5.5h555.2v410H.5z"
      />
      <path
        d="M.5.5v410h555.2V.5zm542 396.75H13.75V13.75H542.5z"
        fill="url(#shutters89)"
      />
      <path
        d="M554.7 1.5v408H1.5V1.5h553.2M12.75 398.25H543.5V12.75H12.75v385.5M555.7.5H.5v410h555.2zM13.75 397.25V13.75H542.5v383.5z"
        fill="#4d4d4d"
      />
      <path
        className="prefix__cls-44"
        d="M551.34 4.88l3.37-3.39v407.99l-3.37-3.36V4.88zM4.88 4.88L1.51 1.49v407.99l3.37-3.36V4.88zM4.87 406.14l-3.38 3.37h553.22l-3.36-3.37H4.87z"
      />
      <path
        className="prefix__cls-44"
        d="M4.87 4.86L1.49 1.49h553.22l-3.36 3.37H4.87z"
      />
    </svg>
  );
};
